// extracted by mini-css-extract-plugin
export default {"cls1":"kYlUE8kn_FcCwi9Nl76k","cls2":"f0TazEW7DcjqW5WFrCl7 kYlUE8kn_FcCwi9Nl76k"};